import styled from 'styled-components';

export const WhiteSpaceStyled = styled.div`
  width: ${({ width }) => width || 1};
  height: ${({ height }) => height || 1};
`;
